import React from 'react'
import { NavLink } from 'react-router-dom'
import { Page, logoutObservable } from '../../components'
import Routes from '../../routes/Routes'
import { withAuth } from '../../utils/withAuth'
import DashboardService from './DashboardService'
import '../../assets/styles/css/dashboard.css'

const NavRoute = ({ children, path }) => (
    <NavLink to={path} className="linkMenu">
        {children}
    </NavLink>
)

const Link = ({ children, link }) => (
    <a href={link} className="linkMenu">
        {children}
    </a>
)

const Item = ({ children }) => <div>{children}</div>

const ItemButton = ({ children, ...props }) => (
    <button type="button" {...props} className="w-full">
        {children}
    </button>
)

class Dashboard extends React.PureComponent {
    generateIcons = user => {
        const items = [
            ...Routes.filter(({ hidden, forbiddenDependent }) => {
                if (hidden) {
                    return false
                } else if (forbiddenDependent && !!user.idDependente) {
                    return false
                }
                return true
            }),
            {
                title: 'Sair',
                icon: 'ic_shutdown.png',
                onClick: () => logoutObservable.onNext(true),
            },
        ]
        return items
    }

    get service() {
        if (!this.service) {
            this.service = new DashboardService(this.props)
        }
        return this.service
    }

    renderIcon = icon => {
        if (icon.isEmpty) {
            return null
        }

        const Element = icon.link
            ? Link
            : icon.path
            ? NavRoute
            : icon.onClick
            ? ItemButton
            : Item

        const item = (
            <div className="flex flex-col gap-3 items-center justify-center mb-6">
                <div className="w-12 h-12">
                    {icon.icon && (
                        <img
                            className="w-full h-full"
                            src={require(`../../assets/icons/${icon.icon}`)}
                            alt={icon.title}
                        />
                    )}
                    {icon.iconView}
                </div>
                <div className="text-[#65B69B] mb-1 mt-2">{icon.title}</div>
            </div>
        )
        if (!!icon.href) {
            return <a {...icon}>{item}</a>
        }

        return <Element {...icon}>{item}</Element>
    }

    render = () => {
        const { isMobile, user } = this.props
        const icons = this.generateIcons(user)
        return (
            <Page
                hideBreadcrumb
                title={isMobile ? 'Painel' : 'Área Administrativa'}
            >
                <div className="grid grid-cols-2 md:grid-cols-4">
                    {icons.map(item => (
                        <div key={item.title}>{this.renderIcon(item)}</div>
                    ))}
                </div>
                {/* {icons.map((chk, indexChk) => (
                    <Grid container key={indexChk} className={indexChk > 0 ? 'iconSection' : ''}>
                        {chk.map((icon, index) => (
                            <Grid item xs={!isMobile ? 3 : 6} style={{ textAlign: 'center' }} key={indexChk * 10 + index} className="iconMenu">
                                {this.renderIcon(icon)}
                            </Grid>
                        ))}
                    </Grid>
                ))}*/}
            </Page>
        )
    }
}

export default withAuth(Dashboard)
